import Swiper from 'swiper/bundle';
( function() {

  const isHome = document.getElementsByClassName('page-id-2');

  if (isHome.length > 0) {

    const gallery = document.querySelector('.home-gallery');

    if (gallery !== null) {

      // wrapper
      const wrapper = gallery.querySelector('div');
      wrapper.classList.add('swiper-wrapper');

      // pagination
      const pagination = document.createElement('div');
      pagination.classList.add('swiper-pagination');
      gallery.appendChild(pagination);

      const option = {
        slidesPerView: 1,
        spaceBetween: 25,
        loop: true,
        autoplay: true,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
        },
        breakpoints: {
          1024: {
            slidesPerView: 'auto',
          }
        },
      };

      const swiper = new Swiper('.home-gallery', option);
    }

    // media query and animation
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    let animations;
    handle(mediaQuery);
    mediaQuery.addListener(handle);
    function handle(mq) {
      if (mq.matches) {

        animations = document.querySelectorAll('.yakult-animation');

        if (animations.length === 0) {

          // TOPICS上の星
          set_animation_object('.home-topics-image', 'stars', 3);

          // TOPICS上の花びら
          set_animation_object('.home-topics-image', 'petals', 3);

          // TOPICS下の星
          set_animation_object('.home-posts-image', 'stars', 5);

          // 花火
          set_animation_object('.home-message-image', 'fireworks', 5);

          // リス
          set_animation_object('.squirrel', 'leaf', 1);

          // 葉っぱ
          set_animation_object('.leaves', 'leaf-wide', 1);
          set_animation_object('.leaves', 'leaf-maple', 1);
        }
      }
    }

    // アニメーションオブジェクトセット
    function set_animation_object(target_key, parent_name, amount) {
      const div = document.createElement('div');
      const target = document.querySelector(target_key);
      const parent = div.cloneNode();

      // 親を挿入
      parent.classList.add('yakult-animation');
      parent.classList.add(parent_name);
      target.insertBefore(parent, null);

      // 親に子を挿入
      for (let i = 1; i <= amount; i++) {
        parent.insertBefore(div.cloneNode(), null);
      }
    }
  }
}() );
